import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from "react";
import RouterWrapper from './auth';



//NO AUTH
import Login from '../Views/Login';
import RecuperarSenha from '../Views/RecuperacaoSenha'
import Page404 from '../Views/404'
import TrocaEmail from '../Views/TrocaEmail'
import Autenticar from '../Views/AutenticarEmail'


//AUTH
import Dashboard from '../Views/Dashboard';
import Perfil from '../Views/Perfil'
import Usuarios from '../Views/Usuarios'

import Investidores from '../Views/Investidores'
import ConfiguracaoBusca from '../Views/ConfiguracaoBusca'
import DatasExibicao from '../Views/DatasExibicao'
import Relatorios from '../Views/Relatorios'
import Investimentos from '../Views/Investimentos'
import Investimento from '../Views/Investimentos/Investimento'
import ObraPainel from '../Views/Investimentos/Obra'
import LoginInvestidor from '../Views/LoginInvestidor'
import InvestimentosInvestidor from '../Views/Investidor/Investimentos'
import InvestimentoInvestidor from '../Views/Investidor/Investimento'


import Tecnico from '../Views/Tecnico'
import Logs from '../Views/Tecnico/Logs'
import Requests from '../Views/Tecnico/Requests'


const Router = () => {

    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])


    const RouterTecnico = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Tecnico} isPrivate={false} />} />
                <Route path="/logs" element={<RouterWrapper component={Logs} isPrivate={false} />} />
                <Route path="/requests" element={<RouterWrapper component={Requests} isPrivate={false} />} />
            </Routes>
        )
    }

    const RouterInvestimento = () => {
        return (
            <Routes>
                <Route path="*" element={<RouterWrapper component={Investimentos} isPrivate={false} />} />
                <Route path="/investimento/:id" element={<RouterWrapper component={Investimento} isPrivate={false} />} />
                <Route path="/investimento/:id/obra/:obraId" element={<RouterWrapper component={ObraPainel} isPrivate={false} />} />
            </Routes>
        )
    }




    return (
        <Routes>
            <Route path="/dashboard" element={<RouterWrapper component={Dashboard} isPrivate={true} />} />
            <Route path="/usuarios" element={<RouterWrapper component={Usuarios} isPrivate={true} />} />
            <Route path="/perfil" element={<RouterWrapper component={Perfil} isPrivate={true} />} />
            <Route path="/investidores" element={<RouterWrapper component={Investidores} isPrivate={true} />} />
            <Route path="/busca-dados" element={<RouterWrapper component={ConfiguracaoBusca} isPrivate={true} />} />
            <Route path="/datas-exibicao" element={<RouterWrapper component={DatasExibicao} isPrivate={true} />} />
            <Route path="/relatorios" element={<RouterWrapper component={Relatorios} isPrivate={true} />} />
            <Route path="/investimentos/*" element={<RouterWrapper component={RouterInvestimento} isPrivate={true} />} />
            <Route path="/tecnicoIndex/*" element={<RouterWrapper component={RouterTecnico} isPrivate={true} />} />
            <Route path="/investidor/investimentos" element={<RouterWrapper component={InvestimentosInvestidor} isPrivate={false} isInvestorPrivate={true} />} />
            <Route path="/investidor/investimentos/investimento/:id" element={<RouterWrapper component={InvestimentoInvestidor} isPrivate={false} isInvestorPrivate={true} />} />
            <Route path="/investidor/investimentos/investimento/:id/obra/:obraId" element={<RouterWrapper component={ObraPainel} isPrivate={false} isInvestorPrivate={true} />} />

            {/* Rotas públicas */}
            <Route path="/investidor/login" element={<RouterWrapper component={LoginInvestidor} isPrivate={false} />} />
            <Route path="/recuperarSenha/:token" element={<RouterWrapper component={RecuperarSenha} isPrivate={false} />} />
            <Route path="/trocarEmail/:token" element={<RouterWrapper component={TrocaEmail} isPrivate={false} />} />
            <Route path="/autenticarEmail/:token" element={<RouterWrapper component={Autenticar} isPrivate={false} />} />
            <Route path="/" element={<RouterWrapper component={Login} isPrivate={false} />} />
            <Route path="*" element={<Page404 />} />
        </Routes>
    )
}

export default Router